<template>
  <div class="manage-tenants">
    <div class="header">
      <label class="search" for="search-tenant">
        <input autocomplete='off' type="text" placeholder="Buscar por nome ou sigla" id="search-tenant" name="search-tenant" v-model="filter.search" @keydown.enter.prevent="getTenants">
        <svg v-if="!filter.search" @click="getTenants" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M17.5002 17.5002L13.881 13.881M13.881 13.881C14.5001 13.2619 14.9912 12.527 15.3262 11.7181C15.6612 10.9093 15.8337 10.0423 15.8337 9.16684C15.8337 8.29134 15.6612 7.42441 15.3262 6.61555C14.9912 5.80669 14.5001 5.07174 13.881 4.45267C13.2619 3.8336 12.527 3.34252 11.7181 3.00748C10.9093 2.67244 10.0423 2.5 9.16684 2.5C8.29134 2.5 7.42441 2.67244 6.61555 3.00748C5.80669 3.34252 5.07174 3.8336 4.45267 4.45267C3.2024 5.70295 2.5 7.39868 2.5 9.16684C2.5 10.935 3.2024 12.6307 4.45267 13.881C5.70295 15.1313 7.39868 15.8337 9.16684 15.8337C10.935 15.8337 12.6307 15.1313 13.881 13.881Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-else @click="filter.search = ''; getTenants()" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M4 4L16 16" stroke="#079F72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M16 4L4 16" stroke="#079F72" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </label>
      <div class="filters">
        <button class="tooltip" @click="$router.push({ name: 'platform-admin.tenants.create' })">
          <figure>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16.0399 3.01976L8.15988 10.8998C7.85988 11.1998 7.55988 11.7898 7.49988 12.2198L7.06988 15.2298C6.90988 16.3198 7.67988 17.0798 8.76988 16.9298L11.7799 16.4998C12.1999 16.4398 12.7899 16.1398 13.0999 15.8398L20.9799 7.95976C22.3399 6.59976 22.9799 5.01976 20.9799 3.01976C18.9799 1.01976 17.3999 1.65976 16.0399 3.01976Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14.9102 4.1499C15.5802 6.5399 17.4502 8.4099 19.8502 9.0899" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </figure>
        </button>
      </div>
    </div>
    <div v-if="tenants && tenants.length" class="tenants">
      <div class="tenants-title doc-grid">
        <label><h1>Tenant</h1></label>
        <label><h1>Setor</h1></label>
        <label><h1>Usuários</h1></label>
        <label><h1>Documentos</h1></label>
        <label><h1>Ações</h1></label>
      </div>
      <div class="tenants-list doc-grid" v-for="tenant in tenants" :key="tenant.id">
        <label class="title">
          <h1>{{ tenant.name }}</h1>
          <h2>{{ tenant.acronym }}</h2>
        </label>
        <label><h1>{{ tenantSectorLabels[tenant.sector] ?? tenant.sector }}</h1></label>
        <label><h1>{{ tenant.users_count }}</h1></label>
        <label><h1>{{ tenant.documents_count }}</h1></label>
        <label class="actions">
          <button class="tooltip" @click="$router.push({ name: 'platform-admin.tenants.edit', params: { id: tenant.id } })">
            <figure>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path fill='none' d="M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.89 5.05078C12.0996 6.39164 12.7486 7.62492 13.735 8.55703C14.7214 9.48914 15.9894 10.0673 17.34 10.2008M3 22.0008H21"  stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </figure>
          </button>
        </label>
      </div>
    </div>
    <div class="no-options" v-else-if="tenants && !tenants.length">
      <h1>Nenhum tenant encontrado</h1>
    </div>
    <SpinnerLoader v-else />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import { TenantModel } from '@/models/TenantModel'
import { tenantSectorLabels } from '@/enums/Tenants/TenantSectorEnum'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'

interface TenantWithCounts extends TenantModel {
  users_count: number
  documents_count: number
}

const axios = useAxios()
const tenants = ref<TenantWithCounts[]>()
const filter = ref<{ search?: string }>({})

onMounted(() => {
  getTenants()
})

function getTenants () {
  tenants.value = undefined
  axios.get('/api/platform-admin/tenants', { params: filter.value })
    .then((res: AxiosResponse<TenantWithCounts[]>) => {
      tenants.value = res.data
    })
    .catch(() => {
      tenants.value = []
    })
}
</script>

<style lang="scss">
  .manage-tenants{
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: start;
    .header{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 20px;
      margin: 0 0 48px 0;
      .search{
        width: 100%;
        max-width: 420px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        input{
            width: 100%;
            height: 55px;
            border: none;
            border-radius: 16px;
            background: #F5F5F5;
            color: $fluxoo-primary-color;
            font-family: 'Inter', sans-serif;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            padding: 20px 56px 20px 20px;
            box-sizing: border-box;
            &:focus{
                outline: none;
                &::placeholder{
                  color: transparent
                }
                & ~ svg{
                  stroke: $fluxoo-primary-color;
                }
            }
            &::placeholder{
                color: #090909;
                font-family: 'Inter', sans-serif;
                font-size: 14px;
                font-style: normal;
                font-weight: 500;
            }
        }
        svg{
            width: 20px;
            min-width: 20px;
            height: 20px;
            min-height: 20px;
            position: absolute;
            right: 20px;
            stroke: #090909;
            cursor: pointer;
        }
      }
      .filters{
        display: flex;
        align-items: center;
        column-gap: 15px;
        button{
          width: 50px;
          height: 50px;
          border-radius: 12px;
          border: 1px solid #D5D5D5;
          transition: border-color .2s;
          cursor: pointer;
          &:hover{
            border-color: $fluxoo-primary-color;
            outline: 1px solid $fluxoo-primary-color;
            svg{
              stroke: $fluxoo-primary-color;
            }
          }
          figure{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            svg{
              width: 24px;
              min-width: 24px;
              height: 24px;
              min-height: 24px;
              stroke: #090909;
              transition: stroke .2s;
            }
          }
          &::before{
            content: 'Novo tenant';
            width: 90px;
            right: -5px;
          }
        }
      }
    }
    .tenants{
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      &-title{
        width: 100%;
        margin: 0 0 -4px 0;
      }
      &-list{
        width: 100%;
        height: 90px;
        border-radius: 24px;
        border: 1px solid #D3D3D3;
        background: #FFF;
        animation: enterContent ease-in-out .6s;
      }
      .doc-grid{
        display: grid !important;
        grid-template-columns: 26% 15% 15% 1fr 68px;
        column-gap: 15px;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;
        box-sizing: border-box;
        label{
          display: flex;
          flex-direction: column;
          align-items: start;
          h1{
            color: #090909;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            text-align: start;
            margin: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          h2{
            color: #6F6F6F;
            font-family: 'Inter', sans-serif;
            font-size: 13px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin: 6px 0 0 0;
          }
          &.title h1{
            -webkit-line-clamp: 2;
          }
          &.actions{
            button{
              width: 24px;
              min-width: 24px;
              height: 24px;
              min-height: 24px;
              cursor: pointer;
              figure{
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;
              }
              svg{
                width: 24px;
                min-width: 24px;
                height: 24px;
                min-height: 24px;
                stroke: #090909;
                transition: stroke .2s;
              }
              &:hover svg{
                stroke: $fluxoo-primary-color;
              }
            }
          }
        }
      }
    }
  }

  @media(max-width: 950px){
    .manage-tenants{
      .tenants{
        .doc-grid{
          grid-template-columns: 1fr 1fr 1fr 68px;
        }
        &-title label:nth-child(2),
        &-list label:nth-child(2){
          display: none;
        }
      }
    }
  }
</style>
